import React from 'react';
import CinematicFooter from './ui/motion-footer';

export default function Footer() {
  return <CinematicFooter />;
}

